import React from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import { Button, Modal, ModalHeader, ModalBody, Row, Col } from 'reactstrap'
import useToggle from '~/hooks/useToggle'

function TopicLink ({ topic, isModalLink, toggleModal, customOnClick }) {
  const linkStyle = `${topic.isActive ? 'text-dark' : 'text-primary'}${isModalLink ? ' font-weight-normal' : ''}`
  let topicLink = null

  if (customOnClick) {
    const onClickFunction = () => {
      customOnClick(topic)

      if (isModalLink) {
        toggleModal()
      }
    }

    topicLink = <a className={linkStyle} onClick={onClickFunction}>{topic.name}</a>
  } else {
    topicLink = (
      <Link href={topic.href} as={topic.as}>
        {isModalLink
          ? <a className={linkStyle} onClick={toggleModal}>{topic.name}</a>
          : <a className={linkStyle}>{topic.name}</a>}
      </Link>
    )
  }

  return (
    <div className={isModalLink ? 'mb-4' : 'mb-1'}>
      {topicLink}
    </div>
  )
}

TopicLink.propTypes = {
  topic: PropTypes.object.isRequired,
  isModalLink: PropTypes.bool,
  toggleModal: PropTypes.func,
  customOnClick: PropTypes.func
}

function TopicLinksModal ({ title, topics, isModalOpen, toggleModal, customOnClick }) {
  return (
    <Modal
      isOpen={isModalOpen}
      toggle={toggleModal}
      modalClassName='d-md-none'
      backdropClassName='d-md-none'
      modalTransition={{ timeout: 0 }}
      backdropTransition={{ timeout: 0 }}
      autoFocus={false}
      size='lg'
    >
      <ModalHeader
        className='border-bottom'
        tag='h2'
        close={<i className='close fa fa-close cursor-pointer' onClick={toggleModal} />}
      >
        {title}
      </ModalHeader>
      <ModalBody className='pt-4'>
        {topics.map(topic => (
          <TopicLink
            topic={topic}
            isModalLink
            toggleModal={toggleModal}
            customOnClick={customOnClick}
            key={topic.name}
          />
        ))}
      </ModalBody>
    </Modal>
  )
}

TopicLinksModal.propTypes = {
  title: PropTypes.string.isRequired,
  topics: PropTypes.array.isRequired,
  isModalOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
  customOnClick: PropTypes.func
}

function TopicLinks ({ title, modalTitle, topics, defaultButtonText, customOnClick }) {
  const [isModalOpen, toggleModal] = useToggle()
  const activeTopic = topics.find(topic => topic.isActive)
  const activeTopicName = activeTopic ? activeTopic.name : defaultButtonText

  return (
    <>
      <div className='d-none d-md-block pt-5'>
        <div className='border-bottom text-secondary font-weight-semibold small pb-2 mb-2 text-uppercase'>
          {title}
        </div>
        {topics.map(topic =>
          <TopicLink topic={topic} customOnClick={customOnClick} key={topic.name} />
        )}
      </div>
      <div className='d-md-none mb-4'>
        <Button className='bg-white text-dark py-2' color='light' outline block onClick={toggleModal}>
          <Row>
            <Col className='text-left'>
              <i className='fa fa-content-copy fa-lg pr-2 text-medium' />
              {activeTopicName}
            </Col>
            <Col xs='auto'><i className='fa fa-chevron-down fa-lg text-medium' /></Col>
          </Row>
        </Button>
      </div>
      <TopicLinksModal
        title={modalTitle}
        topics={topics}
        isModalOpen={isModalOpen}
        toggleModal={toggleModal}
        customOnClick={customOnClick}
      />
    </>
  )
}

TopicLinks.propTypes = {
  title: PropTypes.string.isRequired,
  modalTitle: PropTypes.string.isRequired,
  topics: PropTypes.array.isRequired,
  defaultButtonText: PropTypes.string,
  customOnClick: PropTypes.func
}

export default TopicLinks
